/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable quotes */
import store, { updateModuleState } from "@/store";
import UserDeviceApi from "@/api/userDevice";
import { getCityInfo } from "@/api/native/utils";

// 判断设备信息是否非空
const isUserDeviceNotEmpty = (params: unknown): boolean => Object.prototype.toString.call(params) === "[object Object]"
  && Object.keys(params as Dictionary).length > 0;

// 获取设备信息以及定位信息
const updateGetDeviceInfo = async (): Promise<void> => {
  updateModuleState("base", {
    cityInfo: await getCityInfo(),
  });

  const { cityInfo } = store.state.base;
  // eslint-disable-next-line no-console
  console.error(1004, 'cityInfo', cityInfo);
  const devicesJSON = store.getters["base/devicesJSON"];

  if (isUserDeviceNotEmpty(cityInfo) || isUserDeviceNotEmpty(devicesJSON)) {
    UserDeviceApi.update();
  }
};

export default updateGetDeviceInfo;
